var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6666 14.5337V5.46699C28.6666 3.46699 27.8133 2.66699 25.6933 2.66699H20.3066C18.1866 2.66699 17.3333 3.46699 17.3333 5.46699V14.5337C17.3333 16.5337 18.1866 17.3337 20.3066 17.3337H25.6933C27.8133 17.3337 28.6666 16.5337 28.6666 14.5337Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 17.467V26.5337C14.6666 28.5337 13.8133 29.3337 11.6933 29.3337H6.30665C4.18665 29.3337 3.33331 28.5337 3.33331 26.5337V17.467C3.33331 15.467 4.18665 14.667 6.30665 14.667H11.6933C13.8133 14.667 14.6666 15.467 14.6666 17.467Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M28.6666 26.5333V22.8C28.6666 20.8 27.8133 20 25.6933 20H20.3066C18.1866 20 17.3333 20.8 17.3333 22.8V26.5333C17.3333 28.5333 18.1866 29.3333 20.3066 29.3333H25.6933C27.8133 29.3333 28.6666 28.5333 28.6666 26.5333Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M14.6666 9.20033V5.46699C14.6666 3.46699 13.8133 2.66699 11.6933 2.66699H6.30665C4.18665 2.66699 3.33331 3.46699 3.33331 5.46699V9.20033C3.33331 11.2003 4.18665 12.0003 6.30665 12.0003H11.6933C13.8133 12.0003 14.6666 11.2003 14.6666 9.20033Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.5625001667b8d6786528d623f30c404f.svg";
export { ForwardRef as ReactComponent };